<template>
  <svg
    width="41px"
    height="26px"
    viewBox="0 0 41 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Desktop"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g
        id="D_guidelines"
        transform="translate(-498.000000, -368.000000)"
        stroke="currentColor"
        stroke-width="2"
      >
        <g
          id="Group"
          transform="translate(440.000000, 369.000000)"
        >
          <g
            id="icon-aliments"
            transform="translate(59.000000, 0.000000)"
          >
            <line
              id="Stroke-1"
              x1="8.6265"
              y1="18.8614"
              x2="13.2115"
              y2="21.4754"
            />
            <line
              id="Stroke-2"
              x1="17.2857"
              y1="21.2138"
              x2="25.6897"
              y2="19.1238"
            />
            <line
              id="Stroke-3"
              x1="17.7949"
              y1="17.2931"
              x2="12.7029"
              y2="17.5521"
            />
            <line
              id="Stroke-4"
              x1="0.7322"
              y1="19.3841"
              x2="5.5712"
              y2="20.4301"
            />
            <line
              id="Stroke-5"
              x1="6.844"
              y1="12.5858"
              x2="5.062"
              y2="15.7238"
            />
            <line
              id="Stroke-6"
              x1="18.3047"
              y1="12.8479"
              x2="21.1057"
              y2="16.5079"
            />
            <line
              id="Stroke-7"
              x1="25.1817"
              y1="22.5207"
              x2="29.2537"
              y2="23.3057"
            />
            <line
              id="Stroke-8"
              x1="33.586"
              y1="17.03"
              x2="28.491"
              y2="19.385"
            />
            <line
              id="Stroke-9"
              x1="26.9633"
              y1="11.8024"
              x2="25.9453"
              y2="15.9844"
            />
            <line
              id="Stroke-10"
              x1="10.1554"
              y1="14.1548"
              x2="13.9744"
              y2="12.5848"
            />
            <line
              id="Stroke-11"
              x1="14.7392"
              y1="5.789"
              x2="10.9202"
              y2="9.71"
            />
            <line
              id="Stroke-12"
              x1="16.0133"
              y1="8.9265"
              x2="22.3783"
              y2="10.7555"
            />
            <line
              id="Stroke-13"
              x1="21.3605"
              y1="7.3574"
              x2="18.5595"
              y2="2.6514"
            />
            <line
              id="Stroke-14"
              x1="32.5661"
              y1="14.4162"
              x2="29.7651"
              y2="11.8022"
            />
            <line
              id="Stroke-15"
              x1="32.5661"
              y1="20.691"
              x2="38.6781"
              y2="20.691"
            />
            <line
              id="Stroke-16"
              x1="25.69"
              y1="5.0042"
              x2="23.907"
              y2="8.1422"
            />
            <line
              id="Stroke-17"
              x1="22.236"
              y1="0.7539"
              x2="21.513"
              y2="3.4649"
            />
            <line
              id="Stroke-18"
              x1="23.3397"
              y1="13.9442"
              x2="21.6741"
              y2="13.9442"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: 'IconAliment'
};
</script>

<style lang="scss" scoped>
  svg{
    stroke: currentColor;
  }
</style>
